export default {
  baseUrl:
    process.env.VUE_APP_API_BASE_URL ||
    (process.env.NODE_ENV === 'development'
      ? 'http://localhost'
      : 'https://www.bluebusinessguide.com.au'),
  staging:
    process.env.VUE_APP_STAGING_URL ||
    'https://staging.bluebusinessguide.com.au'
}
